<script lang="ts" setup>
import ProblemPresentationCard from '../ProblemPresentation/ProblemPresentationCard.vue';

defineProps<{
  imageNumber: InstanceType<
    typeof ProblemPresentationCard
  >['$props']['imageNumber'];
}>();
</script>

<template>
  <ProblemPresentationCard :image-number="imageNumber">
    <template #titleText>
      毎月貯金はしてるけど、<span :class="$style['card__text--accent']"
        >このままで本当に足りるの？</span
      >
    </template>
    <template #detail>
      貯金はしているけれど、結婚資金だけでなく、子どもが生まれた後の教育資金や住宅購入資金、さらには老後資金も準備しなければならず、今の貯金額で全てを賄えるか不安。
    </template>
  </ProblemPresentationCard>
</template>

<style lang="scss" module>
.card {
  &__text {
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
